import React, { useState, useEffect } from "react";
import Basket from "../Components/BasketEvents";
import { loadUser } from "../requests";
import { jwtDecode } from "jwt-decode";

export const AccountSpace = () => {
  const [userInfo, setUserInfo] = useState({});

  const fetchData = async () => {
    try {
      let token = "";
      token = localStorage.getItem("accessToken");
      const decodedToken = jwtDecode(token);
      const userResult = await loadUser(decodedToken.sub);
      setUserInfo(userResult);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [userInfo]);
  return (
    <div className="container mt-5">
      <div className="row py-3">
        <div className="col-md-8">
          <Basket />
        </div>
        <div className="col-md-4">
          <h3>Profil</h3>
          <p>Prénom : {userInfo.firstname}</p>
          <p>E-mail : {userInfo.email}</p>
          <p>Rôle : {userInfo.role}</p>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>
      </div>
    </div>
  );
};
